import React, { useMemo, useState, useEffect, memo } from "react";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import draftToHtml from "draftjs-to-html";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import DateTimeDisplay from "../../utils/TimeZoneDisplay";
import * as commonData from "../../Common";

const ErHistory = ({ history, type, users, history_attributes }) => {
  const statusnew = useSelector(
    (state) => state.boardAttribute?.bord_details?.status
  );
  const historyAttributes = useSelector(
    (state) => state.boardAttribute?.history_attributes || history_attributes
  );
  const [show, setShow] = useState(false);
  const [revison_val, setHistoryRevsion] = useState([]);
  const [singleRevision, setSingleRevision] = useState({});
  const [historyUsers, setUsers] = useState({});
  const [effortData, setEffortData] = useState({});
  const getColor = () => {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  useEffect(() => {
    setShow(!show);
    setUsers(users);
  }, []);
  useEffect(() => {
    setHistoryRevsion(history);
  }, [history]);
  function revision(id) {
    setSingleRevision(history.find((item) => item._id === id));
    setShow(true);
  }
  const getEffortData = async () => {
    try {
      if (Object.keys(effortData).length > 0) {
        return;
      }
      const response = await fetch(`${process.env.REACT_APP_API}get-efforts`);
      const rdata = await response.json();
      setEffortData(rdata);
    } catch (err) {
      console.log(err.message);
    }
  };
  const getErHistoryNameImage = (item, new_get_key) => {
    return (
      <>
        {" "}
        <div className="firstLetter">
          <img
            src={`${item?.history_type === 2 || item?.history_type === 3
                ? item.user_details?.profile_image ||
                "https://ui-avatars.com/api/?name=unknown&color=red&size=40&background=random"
                : historyUsers[item.user_uuid]?.profile_image
              }`}
          />
        </div>
        <div className="timeline-panel text-muted" href="#">
          <h6 className="lifecycle_title">
            {getUserDetails(item)}
            {/* {item?.history_type === 2 ? (
              <div className="history_type_check">
                <span>{item?.user_details?.name}</span>{" "}
                <div>
                  <span className="timeline-badge primary"></span>
                </div>
              </div>
            ) : (
              historyUsers[item.user_uuid]?.name
            )} */}
          </h6>
          {getEventSection(item, new_get_key)}

          <div className="adminEtaNew ">
            {getValidDate(item.created_timestamp) && (
              <>
                <DateTimeDisplay dateTime={item.created_timestamp} />
              </>
            )}
            {/* {moment(item.created_date).format(
process.env.REACT_APP_DATE_TIME_FORMAT
)} */}
            {item.event_action == "updated" && (
              <div
                className="float-end muBtn _blue p-0 sm revision-history"
                data-bs-toggle="modal"
                data-bs-target="#system-variables-modal"
                onClick={() => revision(item._id)}
              >
                Revision
              </div>
            )}
          </div>
          {/* <span className="dateNew">
{" "}
{moment(item.created_date).format(
"YYYY-MM-DD h:m:s"
) && moment(item.created_date).fromNow()}
</span> */}
        </div>
      </>
    );
  };
  const getUserDetails = (item) => {
    let user = item.user_details;
    if (item?.history_type === 2 || item?.history_type === 3) {
      return (
        <div className="history_type_check">
          {user && user.profile_url ? (
            <a href={`${user.profile_url}`} target="_blank">
              {user?.name}
            </a>
          ) : (
            <span>{user.name}</span>
          )}
          {item?.history_type !== 3 && (
            <div>
              <span className="timeline-badge primary"></span>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="history_type_check">
          {historyUsers[item.user_uuid] &&
            historyUsers[item.user_uuid]?.profile_url ? (
            <a
              href={`${historyUsers[item.user_uuid]?.profile_url}`}
              target="_blank"
              className="checkUserNameNote"
            >
              {historyUsers[item.user_uuid]?.name}
            </a>
          ) : (
            <span>{historyUsers[item.user_uuid]?.name}</span>
          )}
        </div>
      );
    }
  };

  //Get the customer note uuid
  const getTheNoteId = (item) => {
    if (
      item.hasOwnProperty("new") ||
      (item.hasOwnProperty("old") &&
        item.new.hasOwnProperty("custom_note_uuid")) ||
      item.old.hasOwnProperty("custom_note_uuid")
    ) {
      return item.new?.custom_note_uuid || item.old?.custom_note_uuid;
    }
  };

  const getEventSection = (item, new_get_key) => {
    if (item.event_name == "note") {
      return (
        <span class="dateNew text-capitalize d-flex leftSide">
          {item.event_name} =&gt; {item.event_action} : {getTheNoteId(item)}
        </span>
      );
    }
    if (item?.event_name === "project_plan") {
      return (
        <span className="dateNew text-capitalize d-flex leftSide">
          {item?.event_name.split("_").join(" ")}&nbsp; => {item.event_action}
        </span>
      );
    }
    if (item?.event_action === "added" && item?.event_name === "relationship") {
      return (
        <span className="dateNew text-capitalize d-flex leftSide">
          {item.event_action === "updated"
            ? item.history_type === 2
              ? item?.event_name
              : historyAttributes.hasOwnProperty(new_get_key?.[0])
                ? historyAttributes[new_get_key?.[0]]
                : new_get_key?.[0]
            : item.event_name}{" "}
          => {item.event_action}(
          <Link
            to={
              item.hasOwnProperty("new")
                ? `${Object.values(item?.new)?.[0]}`
                : ""
            }
            target="_blank"
          >
            {item.hasOwnProperty("new")
              ? `${Object.keys(item?.new)?.[0]} : ${Object.values(item?.new)?.[0]
              }`
              : ""}
          </Link>
          )
        </span>
      );
    }
    if (item.event_name === "child" && item.event_action === "added") {
      let link = "//" + process.env.REACT_APP_LOCAL_URL + "/tattle/";
      if (item.hasOwnProperty("new") && Object.values(item.new).length > 0) {
        if (Object.keys(item?.new)?.[0] === "WBS") {
          link += "task" + "/" + Object.values(item?.new)?.[0];
        } else {
          link +=
            Object.keys(item?.new)?.[0]?.toLowerCase() +
            "/" +
            Object.values(item?.new)?.[0];
        }
      }
      return (
        <span className="dateNew text-capitalize d-flex leftSide">
          {Object.keys(item.new)[0]}&nbsp; => {item.event_action} (
          <Link to={link} target="_blank">
            {item.hasOwnProperty("new")
              ? `${Object.keys(item?.new)?.[0]} : ${Object.values(item?.new)?.[0]
              }`
              : ""}
          </Link>
          )
        </span>
      );
    }
    if (item.event_name === "er" && item.event_action === "cloned") {
      let link = "//" + process.env.REACT_APP_LOCAL_URL + "/tattle/";
      if (item.hasOwnProperty("new") && Object.values(item.new).length > 0) {
        link += "er" + "/" + Object.values(item?.new)?.[0];
      }
      return (
        <span className="dateNew text-capitalize d-flex leftSide">
          {Object.keys(item.new)[0]}&nbsp; => {item.event_action} (
          <Link to={link} target="_blank">
            {item.hasOwnProperty("new")
              ? `${Object.keys(item?.new)?.[0]} : ${item?.new[Object.keys(item?.new)?.[0]]
              }`
              : ""}
          </Link>
          )
        </span>
      );
    }
    if (item.event_name === "child" && item.event_action === "removed") {
      let link = "//" + process.env.REACT_APP_LOCAL_URL + "/tattle/";
      if (item.hasOwnProperty("new") && Object.values(item.new).length > 0) {
        link +=
          Object.keys(item?.new)?.[0] + "/" + Object.values(item?.new)?.[0];
      }
      return (
        <span className="dateNew text-capitalize d-flex leftSide">
          {Object.keys(item.new)[0]}&nbsp; => {item.event_action}
        </span>
      );
    }
    if (
      (item.event_name === "tattle" && item.event_action === "closed") ||
      item.event_action === "reopen"
    ) {
      let link = "//" + process.env.REACT_APP_LOCAL_URL + "/tattle/";
      if (item.hasOwnProperty("new") && Object.values(item.new).length > 0) {
        link +=
          Object.keys(item?.new)?.[0] + "/" + Object.values(item?.new)?.[0];
      }
      return (
        <span className="dateNew text-capitalize d-flex leftSide">
          {Object.keys(item.new)[0]}&nbsp; => {item.event_action}
        </span>
      );
    }
    if (item.event_name === "tattle" && item.event_action === "pause") {
      return (
        <span className="dateNew text-capitalize d-flex leftSide">
          {item.attribute_set_key.toUpperCase()}&nbsp; => {item.event_action}
        </span>
      );
    }
    if (item.event_name === "tattle" && item.event_action === "created") {
      if (item.attribute_set_key.includes("-")) {
        return (
          <span className="dateNew text-capitalize d-flex leftSide">
            {item.attribute_set_key
              .split("-")
              .map((ite) => ite)
              .join(" ")}
            &nbsp; => {item.event_action}
          </span>
        );
      }

      return (
        <span className="dateNew text-capitalize d-flex leftSide">
          {item.attribute_set_key.toUpperCase()}&nbsp; => {item.event_action}
        </span>
      );
    }
    if (item.event_name === "sla" && item.event_action === "missed") {
      return (
        <span className="dateNew text-capitalize d-flex leftSide">
          <span className="text-uppercase"> {item.event_name}{" "}</span>
          => {item.event_action} : {(item.new.reason ?? '')
            .replace(/_/g, ' ')
            .replace(/\ber\b/gi, 'ER')}
        </span>
      );
    }
    return (
      <span className="dateNew text-capitalize d-flex leftSide">
        {item.event_action === "updated"
          ? item.history_type === 2
            ? item?.event_name
            : historyAttributes.hasOwnProperty(new_get_key?.[0])
              ? historyAttributes[new_get_key?.[0]] === "url"
                ? "URL"
                : historyAttributes[new_get_key?.[0]]
              : callEvaluate(new_get_key, item) === "url"
                ? "URL"
                : callEvaluate(new_get_key, item)
          : item.event_name}{" "}
        => {item.event_action.replace(/_/g, ' ')}

      </span>
    );
  };
  const getKeyNameField = (key) => {
    if (key.indexOf("_") !== -1) {
      return key
        .split("_")
        .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
        .join(" ");
    } else {
      return key.charAt(0).toUpperCase() + key.slice(1);
    }
  };
  const getHistoryCustomContent = (old, rnew) => {
    if (old || rnew) {
      if (
        old ||
        (rnew && Object.keys(old).length > 1) ||
        Object.keys(rnew).length > 1
      ) {
        let olddate = Object.entries(old).map(([key, value]) => ({
          key,
          value,
        }));
        let newdate = Object.entries(rnew).map(([key, value]) => ({
          key,
          value,
        }));

        getEffortData();
        {
          let confirmval = olddate.length > 0 ? olddate : newdate;

          return confirmval
            .sort((a, b) => a["key"].localeCompare(b["key"]))
            .filter(
              (it) => it.key !== "total_hours" && it.key !== "effort_type"
            )
            .map((oldObj) => {
              const newObj = newdate.find(
                (newObj) => newObj.key === oldObj.key
              );
              return (
                <tr key={oldObj.key}>
                  <td>
                    {getKeyNameField(oldObj.key) === "Url"
                      ? "URL"
                      : getKeyNameField(oldObj.key)}
                  </td>{" "}
                  <td>
                    {oldObj.key === "effort" &&
                      olddate.length === 0 &&
                      oldObj.value == ""
                      ? ""
                      : olddate.length > 0 && oldObj.value
                        ? oldObj?.value == true
                          ? "Yes"
                          : oldObj?.value == false
                            ? "No"
                            : oldObj?.value
                        : oldObj.key === "effort" ||
                          oldObj.key === "start_date" ||
                          oldObj.key === "end_date" ||
                          oldObj.key === "qa_start_date"
                          ? ""
                          : oldObj?.value == ""
                            ? ""
                            : oldObj.value == false
                              ? "No"
                              : "0"}
                  </td>
                  <td></td>
                  <td>
                    {newObj
                      ? newObj.value == true
                        ? "Yes"
                        : newObj.value == ""
                          ? ""
                          : newObj.value == false
                            ? "No"
                            : newObj.value
                      : "0"}
                  </td>{" "}
                </tr>
              );
            });
        }
      }
      return (
        <tr>
          <td
            dangerouslySetInnerHTML={{
              __html: Object.values(old || {}),
            }}
          ></td>
          <td></td>
          <td
            dangerouslySetInnerHTML={{
              __html: Object.values(rnew || {}),
            }}
          ></td>
        </tr>
      );
    }
  };
  const checkandjoinword = (string) => {
    const splitword = string.split("_");
    return splitword
      .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
      .join(" ");
  };

  const callEvaluate = (new_get_key, item) => {
    new_get_key.sort((a, b) => a.localeCompare(b));
    const { new: nitem, old } = item;
    return nitem?.hasOwnProperty("effort_type") ||
      old?.hasOwnProperty("effort_type")
      ? history_attributes[nitem?.effort_type || old?.effort_type]
      : new_get_key?.[0]?.includes("_")
        ? history_attributes[new_get_key[0]]
        : new_get_key[0];
  };
  const getValidDate = (timestamp) => {
    const parseDate = new Date(timestamp);
    return !isNaN(parseDate) && parseDate.toString() != "invalid date";
  };
  const getHeaderAction = () => {
    if (singleRevision.event_name == "project_plan") {
      let eventname = singleRevision.event_name.split("_").join(" ");
      return `${eventname.charAt(0).toUpperCase() + eventname.slice(1, eventname.length)
        } Changed By ${historyUsers[singleRevision.user_uuid]?.name}`;
    }
    return (
      <>
        {singleRevision?.new?.hasOwnProperty("effort_type") ||
          singleRevision?.old?.hasOwnProperty("effort_type")
          ? history_attributes[singleRevision?.new?.effort_type] ||
          singleRevision?.old?.effort_type
            .split("_")
            .map((ite) =>
              ite === "qa"
                ? history_attributes["qa_effort"]
                : history_attributes[ite]
            )
            .join(" ")
          : singleRevision?.new
            ? historyAttributes[Object.keys(singleRevision.new)?.[0]] ||
              Object.keys(singleRevision.new)?.[0].includes("_")
              ? history_attributes.hasOwnProperty(
                Object.keys(singleRevision.new)?.[0]
              )
                ? history_attributes[Object.keys(singleRevision.new)?.[0]]
                : checkandjoinword(Object.keys(singleRevision.new)?.[0])
              : Object.keys(singleRevision.new)?.[0]
            : ""}{" "}
        Changed By {historyUsers[singleRevision.user_uuid]?.name}
      </>
    );
  };

  const getNoteModalData = () => {
    const { new: rnew, old, event_name, event_action } = singleRevision;
    if (event_name === "project" && event_action === "updated") {
      let olddate = Object.entries(old).map(([key, value]) => ({ key, value }));
      let newdate = Object.entries(rnew).map(([key, value]) => ({
        key,
        value,
      }));
      return (
        <tr>
          <td>{history_attributes[olddate[0]?.key || newdate[0]?.key]}</td>
          <td>
            {Array.isArray(olddate?.[0]?.value)
              ? olddate?.[0]?.value.length > 0 && olddate?.[0]?.value?.join(",")
              : olddate?.[0]?.value}
          </td>
          <td></td>
          <td>
            {Array.isArray(newdate?.[0]?.value)
              ? newdate?.[0]?.value.length > 0 && newdate?.[0]?.value?.join(",")
              : newdate?.[0]?.value}
          </td>
        </tr>
      );
    }
    if (event_name === "project_plan" && event_action === "updated") {
      let olddate = Object.entries(old).map(([key, value]) => ({ key, value }));
      let newdate = Object.entries(rnew).map(([key, value]) => ({
        key,
        value,
      }));
      return (
        <tr>
          <td>
            {" "}
            {newdate.map((item) => {
              let keyname =
                item["key"] !== "note_content"
                  ? item["key"]
                  : item["key"].split("_").join(" ");
              return (
                <>
                  {history_attributes.hasOwnProperty(keyname) &&
                    item["key"] !== "note_content"
                    ? history_attributes[keyname]
                    : item["key"] !== "note_content" &&
                    keyname.charAt(0).toUpperCase() +
                    keyname?.slice(1, keyname.length)}
                  <br />
                </>
              );
            })}
          </td>
          <td>
            {" "}
            {olddate.map((item) => (
              <>
                {item["key"] !== "note_content" &&
                  !isNaN(Date.parse(item["value"]))
                  ? moment(item["value"]).format("DD-MM-YYYY")
                  : ""}{" "}
                <br />
              </>
            ))}
          </td>
          <td></td>
          <td>
            {newdate.map((item) => (
              <>
                {item["key"] !== "note_content" &&
                  !isNaN(Date.parse(item["value"]))
                  ? moment(item["value"]).format("DD-MM-YYYY")
                  : ""}
                <br />
              </>
            ))}
          </td>
        </tr>
      );
    }
    if (event_name === "note") {
      return (
        <tr>
          <td
            dangerouslySetInnerHTML={{
              __html: old?.note_content,
            }}
          ></td>
          <td></td>
          <td
            dangerouslySetInnerHTML={{
              __html: rnew && rnew?.note_content,
            }}
          ></td>
        </tr>
      );
    } else if (event_name === "status") {
      return (
        <tr>
          <td>
            {typeof old === "object" && old !== null
              ? history_attributes[
              Object.keys(old)[0] || Object.keys(rnew)?.[0]
              ]
              : ""}
          </td>
          <td
            dangerouslySetInnerHTML={{
              __html: old?.status,
            }}
          ></td>
          <td></td>
          <td
            dangerouslySetInnerHTML={{
              __html: rnew?.status,
            }}
          ></td>
        </tr>
      );
    } else {
      return getHistoryCustomContent(old, rnew);
    }
  };

  return (
    <div>
      {show ? (
        <>
          <div
            className="modal fade"
            id="system-variables-modal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="addPersionTitle"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header pb-2 pt-4 align-items-start">
                  <div className="d-flex flex-column">
                    <h4 className="modal-title">History Revision</h4>
                    <p className="modal-subtitle m-0 text-capitalize">
                      {getHeaderAction()}
                    </p>
                  </div>
                  <div
                    className="close erclosehis"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </div>
                </div>
                <div className="modal-body py-0">
                  <div className="table-responsive">
                    <table
                      className="table align-center border border-light"
                      id="system_variable_att"
                    >
                      <thead>
                        <tr>
                          {/* {singleRevision.event_name === "project_plan" && (
                            <th>Fields</th>
                          )} */}
                          <th>Fields</th>
                          <th>From</th>
                          <th>=></th>
                          <th>To</th>
                        </tr>
                      </thead>
                      <tbody>{getNoteModalData()}</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </>
      ) : (
        ""
      )}{" "}
      <div className="rightER-history">
        <div className="timeline-title">Tattle History</div>
        <Row>
          <Col md={12} xs={12} sm={12} lg={12}>
            <div className="widget-timeline demo-y">
              <ul className="timeline">
                {revison_val.length > 0 &&
                  revison_val?.map((item, index) => {
                    const new_get_key =
                      item?.new && Object.keys(item?.new || {});
                    const vall = item?.new && item?.new[new_get_key?.[0]];

                    return (
                      <li className="history-section" key={index}>
                        {getErHistoryNameImage(item, new_get_key)}
                      </li>
                    );
                  })}
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default memo(ErHistory);
